/* eslint no-underscore-dangle: ["error", { "allow": ["__queryID", "__position"] }] */
import aa from "search-insights";

import { jjLogger } from "utils/logUtils";
import MakePresenter from "presenters/MakePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

import useSettings from "./useSettings";
import useUsers from "./useUsers";
import useAlgoliaTracker from "./useAlgoliaTracker";

const useAlgoliaEvents = () => {
  const {
    settings: { algolia },
  } = useSettings();
  const { currentUser } = useUsers();
  const { setHitSelected, clearHitSelected, hitSelected } = useAlgoliaTracker();

  const getUser = () => {
    if (currentUser) return currentUser.id;

    let userToken;
    aa("getUserToken", null, (err, newUserToken) => {
      if (err) {
        jjLogger.log(`useAlgoliaEvents.js - getUser() - Error while generating newUserToken - ${err}`);
        return;
      }
      userToken = newUserToken;
    });
    return userToken;
  };

  const trackEventAfterSearch = (item) => {
    aa("clickedObjectIDsAfterSearch", {
      userToken: getUser(),
      eventName: "click_on_after_search",
      index: algolia.indexName,
      queryID: item.__queryID,
      objectIDs: [item.objectID],
      positions: [item.__position],
    });

    setHitSelected(item);
  };

  const trackEventAfterSearchAndPurchase = (item) => {
    aa("convertedObjectIDsAfterSearch", {
      userToken: getUser(),
      eventName: "purchase_after_search",
      index: algolia.indexName,
      queryID: item.__queryID,
      objectIDs: [item.objectID],
    });
  };

  const trackEventAfterSearchAndShare = (make) => {
    if (MakePresenter.templateGroupId(make) === hitSelected?.objectID) {
      aa("convertedObjectIDsAfterSearch", {
        userToken: getUser(),
        eventName: "share_after_search",
        index: algolia.indexName,
        queryID: hitSelected.__queryID,
        objectIDs: [hitSelected.objectID],
      });

      clearHitSelected();
    }
  };

  const trackEventAfterSearchAndMakeIsPreview = (make, templateGroup) => {
    if (TemplateGroupPresenter.id(templateGroup) === hitSelected?.objectID && MakePresenter.isDraft(make)) {
      aa("convertedObjectIDsAfterSearch", {
        userToken: getUser(),
        eventName: "make_preview_after_search",
        index: algolia.indexName,
        queryID: hitSelected.__queryID,
        objectIDs: [hitSelected.objectID],
      });
    }
  };

  return {
    trackEventAfterSearch,
    trackEventAfterSearchAndPurchase,
    trackEventAfterSearchAndShare,
    trackEventAfterSearchAndMakeIsPreview,
  };
};

export default useAlgoliaEvents;
